import { FirebaseMessaging } from '@capacitor-firebase/messaging'
import EnvUtils from '~/src/utils/EnvUtils'

interface ReturnsType {
  stop(): Promise<void>,
}

const useStopPushNotifications = (): ReturnsType => {
  const stop = async (): Promise<void> => {
    if (EnvUtils.isDeviceWeb) {
      return
    }

    return FirebaseMessaging.removeAllListeners()
  }

  return { stop }
}

export default useStopPushNotifications
